import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';
import { useEffect, useState } from "react";
import { LinearProgress, Tabs } from '../../tailwindcomponents';
import taskApi from '../../api/tasks';
import FlightScheduleView from '../Line/FlightSchedule';
import LineWorkPackageOverview from '../../components/LinePlanner/LinePlannerWorkPackageOverview';
import { HangarOverview } from '../HangarOverview';
import { HandoverReportList } from '../../components/Handover';
import { linePlannerHandoverConfig } from './linePlannerHandoverConfig';
import LinePlannerIssueHistory from './LinePlannerIssueHistory';
import { useQueryTab } from '../../utils/usePersistedTab';
import WorkPackageCalendar from '../Line/WorkPackageCalendar';

const LinePlanner = () => {
  const store = useSelector((state: RootState) => state);
  const accessGroups = store.user.me.user_clearence_groups;
  const isLineKefCalendarAdmin = accessGroups.includes("Line Planner") || accessGroups.includes("Line Supervisor Edit");
  const isRkvAdmin = accessGroups.includes("Rvk Line Edit") || accessGroups.includes("Rvk Line View");
  const [loading, setLoading] = useState<boolean>(true);
  const { tabValue, setTabValue } = useQueryTab("tab", 0);
  const [allTails, setAllTails] = useState<Array<string>>([]);
  const isLineSupervisorAdmin = accessGroups.includes("Line Supervisor Edit");

  useEffect(() => {
    if (tabValue === 0 || tabValue === 1) {
      refresh();
    }
    else if (tabValue === 7) {
      handlePowerBiRedirect();
    }
  }, [tabValue]);

  const handlePowerBiRedirect = () => {
    window.open(
      `${process.env.REACT_APP_RESOURCE_MANAGEMENT_POWER_BI}`,
      "_blank",
      "noopener,noreferrer"
    );
  };


  const refresh = () => {
    setLoading(true);
    taskApi.GetAllTailNumbers().then(res => {
      setAllTails(res.data);
    });
  }

  return (
    <div>
      {loading && <LinearProgress />}
      < Tabs
        tabNames={["Work Package Overview", "Icelandair Flight Schedule", "Line Kef calendar", "Line RKV Calendar", "Hangar overview", "Line Planner Handover", "Issue History", "Resource Mgmt"]}
        onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
        tabValue={tabValue}
      />
      {tabValue === 0 && <div> <LineWorkPackageOverview allTails={allTails} setLoadingProp={(loading: boolean) => setLoading(loading)} /></div>}
      {tabValue === 1 && <FlightScheduleView isLineSupervisorAdmin={isLineSupervisorAdmin} setLoading={setLoading} />}
      {tabValue === 2 && <WorkPackageCalendar setLoading={setLoading} isAdmin={isLineKefCalendarAdmin} accessGroups={accessGroups} location="KEF" />}
      {tabValue === 3 && <WorkPackageCalendar setLoading={setLoading} isAdmin={isRkvAdmin} accessGroups={accessGroups} location="RKV" />}
      {tabValue === 4 && <HangarOverview isLinePlannerTab={true} />}
      {tabValue === 5 && <HandoverReportList config={linePlannerHandoverConfig} setLoading={setLoading} />}
      {tabValue === 6 && <LinePlannerIssueHistory setLoading={setLoading} />}
      {tabValue === 7 &&
        <div>
          <iframe id="resource-management" title="Resource Management" width="100%" height="1200px" src={process.env.REACT_APP_RESOURCE_MANAGEMENT_POWER_BI} allowFullScreen={true}></iframe>
        </div>}
    </div>
  )
}
export default LinePlanner;